import { type Api } from "api-client";
import { observer } from "mobx-react-lite";
import {
  useState,
  useContext,
  createContext,
  type PropsWithChildren,
} from "react";

import { QuestionnaireSubmissionStore } from "./QuestionnaireSubmissionStore";

const QuestionnaireSubmissionContext =
  createContext<QuestionnaireSubmissionStore | null>(null);

export interface QuestionnaireSubmissionContextProviderProps extends PropsWithChildren {
  questionnaireSubmission: Api.GetSubmission.Output.Self;
}

export const QuestionnaireSubmissionContextProvider = observer(
  function QuestionnaireSubmissionContextProvider(
    props: QuestionnaireSubmissionContextProviderProps,
  ) {
    const [questionnaireSubmissionStore] = useState(() => {
      const store = new QuestionnaireSubmissionStore();
      store.setQuestionnaireSubmission(props.questionnaireSubmission);
      return store;
    });

    return (
      <QuestionnaireSubmissionContext.Provider
        value={questionnaireSubmissionStore}
      >
        {props.children}
      </QuestionnaireSubmissionContext.Provider>
    );
  },
);

export function useQuestionnaireSubmissionContext() {
  const questionnaireSubmissionContext = useContext(
    QuestionnaireSubmissionContext,
  );

  if (questionnaireSubmissionContext === null) {
    throw new Error(
      "useQuestionnaireSubmissionContext must be used within QuestionnaireSubmissionStoreProvider",
    );
  }

  return questionnaireSubmissionContext;
}
